export const enum KeyCode {
  // Navigation
  UP = "ArrowUp",
  DOWN = "ArrowDown",
  LEFT = "ArrowLeft",
  RIGHT = "ArrowRight",

  // Editing
  BACKSPACE = "Backspace",
  DELETE = "Delete",
  ESCAPE = "Escape",

  // Modifiers
  CTRL_LEFT = "ControlLeft",
  CTRL_RIGHT = "ControlRight",
  SHIFT_LEFT = "ShiftLeft",
  SHIFT_RIGHT = "ShiftRight",
  ALT_LEFT = "AltLeft",
  ALT_RIGHT = "AltRight",
  META_LEFT = "MetaLeft",
  META_RIGHT = "MetaRight",

  // Letters
  A = "KeyA",
  B = "KeyB",
  C = "KeyC",
  D = "KeyD",
  E = "KeyE",
  F = "KeyF",
  G = "KeyG",
  H = "KeyH",
  I = "KeyI",
  J = "KeyJ",
  K = "KeyK",
  L = "KeyL",
  M = "KeyM",
  N = "KeyN",
  O = "KeyO",
  P = "KeyP",
  Q = "KeyQ",
  R = "KeyR",
  S = "KeyS",
  T = "KeyT",
  U = "KeyU",
  V = "KeyV",
  W = "KeyW",
  X = "KeyX",
  Y = "KeyY",
  Z = "KeyZ",

  // Numbers
  _0 = "Digit0",
  _1 = "Digit1",
  _2 = "Digit2",
  _3 = "Digit3",
  _4 = "Digit4",
  _5 = "Digit5",
  _6 = "Digit6",
  _7 = "Digit7",
  _8 = "Digit8",
  _9 = "Digit9",
}
